export enum RecipientTypeEnum {
  Individual = 'individual',
  Business = 'business',
}

export enum PaymentMethodTypeEnum {
  Card = 'card',
  BankAccount = 'bank_account',
}

export enum BankAccountTypeEnum {
  Checking = 'checking',
  Savings = 'savings',
}

export enum PaymentMethodRecipientNamePreference {
  PersonalName = 'personal_name',
  BusinessName = 'business_name',
}

export enum PaymentMethodStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
}

export enum CardType {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Amex = 'amex',
  Discover = 'discover',
}

export interface ContractorPaymentMethod {
  id: string
  status: PaymentMethodStatus
  paymentMethodType: PaymentMethodTypeEnum
  recipientType?: RecipientTypeEnum | null
  recipientNamePreference?: PaymentMethodRecipientNamePreference | null
  cardNumberLast4?: string | null
  cardExpiration?: string | null
  cardType?: CardType | null
  zipcode?: string | null
  bankAccountType?: BankAccountTypeEnum | null
  bankAccountNumberLast4?: string | null
  bankRoutingNumberLast4?: string | null
  payeeToken: string
  activatedAt?: string | null
  deactivatedAt?: string | null
  partnerDriverId: string
  createdAt: number
  updatedAt: number
}
